import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";



const CreateSession = createAsyncThunk('CreateSession', async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post('/company/createSession' , data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
})


const CreateSessionSlice = createSlice({
    name: 'company',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(CreateSession.pending, (state) => {
                state.loading = true;
                state.isError = false;
                state.isSuccess = false;
                state.data = null;
                state.error = null;
            })
            .addCase(CreateSession.rejected, (state, action) => {
                state.loading = true;
                state.isError = true;
                state.isSuccess = false;
                state.data = null;
                state.error = action.payload || action.error.message;
            })
            .addCase(CreateSession.fulfilled, (state, action) => {
                state.loading = false;
                state.isError = false;
                state.isSuccess = true;
                state.data = action.payload;

            })
    }
})



export { CreateSession };
export default CreateSessionSlice.reducer;
